import React, { useRef, useEffect, useState } from 'react';
import { gsap } from 'gsap';
import './Carousel.css'; // Ensure you have appropriate styles

const Carousel = ({ images }) => {
  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    gsap.to(carouselRef.current.children, {
      xPercent: -100 * currentIndex,
      duration: 1,
      ease: "back.in",
    });
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="carousel-container">
      <button onClick={handlePrev} className="carousel-button">&lt;</button>
      <div className="carousel" ref={carouselRef}>
        {images.map((image, index) => (
          <div className="carousel-item" key={index}>
            <img loading="lazy" decoding="async" src={image} alt={`Slide ${index}`} />
          </div>
        ))}
      </div>
      <button onClick={handleNext} className="carousel-button">&gt;</button>
    </div>
  );
};

export default Carousel;
